import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-in-the-news-container',
  imports: [CommonModule,RouterModule],
  standalone:true,
  templateUrl: './in-the-news-container.component.html',
  styleUrl: './in-the-news-container.component.scss'
})
export class InTheNewsContainerComponent {

}
